import React, { useEffect, useState } from "react";
import "./ContactDetailsBanner.css";
import { MapPin, Mail, Linkedin,Phone, PhoneMissed } from "react-feather";
import { enrichContact, enrichContactV2, getCreditBalance } from "../../../../../services/iqApiV2";
import { useDispatch } from "react-redux";
import { useUser } from "../../../../../context/UserContext";
import { updateContactEmailUpdate, updateContactPhoneUpdate } from "../../../../../store/features/actions/targetedReachout/spotContactsActions";
import AccessField from "../../Opportunities/accessEmailComp/AccessField";
import ContactDetailsBannerBadge from "./ContactDetailsBannerBadge";
import AccessPhoneButton from "../../Opportunities/accessEmailComp/AccessPhoneField";
import GenericFloatingBanner from "../../../genericComponents/uiElements/GenericFloatingBanner";
import { addStreamListener, initStreamSW, startPhoneStream } from "../../../../../streaming/streamSwClient";
import StatusIndicator from "../../../genericComponents/resizeableTable/StatusIndicator";

const getInitials = (fullName) => {
  if (!fullName) return "";
  const words = fullName.trim().split(" ");
  const initials = words
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");
  return initials;
};

const ContactDetailsBanner = ({
  name,
  title,
  company,
  location,
  email,
  linkedin,
  decisionMaker = false,
  personaInsights = {},
  contactId,
  phone
}) => {
  
    const [banner, setBanner] = useState(null);
    const [isPhonePending,setIsPhonePending]=useState(false);
    

    useEffect(() => {
       const key = `${user.id}_${contactId}_phone_pending`;
       if (localStorage.getItem(key)) {
        setIsPhonePending(true)
       }

    }, [contactId])
    
    
  const triggerBanner = ({ message, type = "info", duration = 4000 }) => {
        setBanner({
          id: Date.now(),
          message,
          type,
          duration,
          title:""
        });
  };
    const copyToClipboard = (text, type = "email") => {
    navigator.clipboard.writeText(text)
      .then(() => {

        triggerBanner({
          message: type === "phone" ? "Phone Number Copied Successfully" : "Email Copied Successfully",
          type: "success",
          duration: 10000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };




    useEffect(() => {
      debugger
        let removeListener = null;
    
        const setup = async () => {
          try {
            await initStreamSW().then(()=>{
              removeListener = addStreamListener((msg) => {
              debugger
              if (msg.type === "PHONE_UPDATE") {
                const key = `${user?.id}_${msg.apolloId}_phone_pending`;
                localStorage.removeItem(key)
                 setUpdatedPhone(msg?.phone);
                //  dispatch(updateContactPhoneUpdate(msg.apolloId, msg?.phone));
                 debugger
                 setIsPhonePending(false)
              }
              if (msg.type === "PHONE_UPDATE_ERROR") {
                const key = `${user?.id}_${msg.apolloId}_phone_pending`;
                localStorage.removeItem(key)
                setUpdatedPhone("Not Found")
                // dispatch(updateContactPhoneUpdate(msg.apolloId, "Not Found"));
                debugger
                setIsPhonePending(false)
                console.log("No phone found:", msg.message);
              }

              console.log("initStreamSW",msg)
            });
            }).catch((err)=>{
              debugger
              console.log("initStreamSW err",err)}
            
            )
    
            
          } catch (err) {
            console.error("Stream SW init failed:", err);
          }
        };
    
        setup();
    
        return () => {
          if (typeof removeListener === "function") {
            debugger
            removeListener(); // safely remove listener
          }
        };
      }, []);

  const handleOnAccessPhoneClick = async (e, userId, apolloId, phoneAccess = false) => {
      e.preventDefault();
      e.stopPropagation();
      triggerBanner({
          message: `Contact is being fetched , Might take upto 5 minutes`,
          type: "success",
          duration: 3000,
        });
      try {
        const requiredCredits = phoneAccess ? 10 : 2;
        const balance = await getCreditBalance(userId);
        if (balance < requiredCredits) {
          // Show banner if insufficient credits
  
          triggerBanner({
            message: `Insufficient credits to ${phoneAccess ? "access phone" : "access email"
              }. Please recharge to continue.`,
            type: "warning",
            duration: 10000,
          });
          return;
        }
        const resp = await enrichContactV2(userId, apolloId, phoneAccess, () => { }, () => { });
  
        if (phoneAccess) {
          const key = `${user.id}_${apolloId}_phone_pending`;
          localStorage.setItem(key, JSON.stringify({
            ts: Date.now()
          }));
          startPhoneStream(apolloId);
        }

        const updatedPhone1 = resp?.phone;
        setIsPhonePending(true)
        setUpdatedPhone(updatedPhone1)
        dispatch(updateContactPhoneUpdate(apolloId, updatedPhone1));
        debugger
        await Promise.resolve();
      } catch (err) {
        console.error("Failed to enrich contact:", err);
      }
    };
  const BANT_FRAMEWORK = personaInsights?.bant_framework ?? null;
  const DECISION_MAKER_STAT = personaInsights?.decision_maker_status ?? null;

  const NO_EMAIL = "email_not_unlocked@domain.com";
  const [updatedEmail, setUpdatedEmail] = useState(email);
  const [updatedPhone, setUpdatedPhone] = useState(phone);
  const initials = getInitials(name);
  const { user } = useUser();
  const dispatch = useDispatch();

  const handleOnAccessEmailClick = async (e, userId, apolloId, linkedInUrl) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      const resp = await enrichContact(userId, apolloId, linkedInUrl);
      const updatedEmail = resp?.email;
      dispatch(updateContactEmailUpdate(apolloId, updatedEmail));
      if (updatedEmail) setUpdatedEmail(updatedEmail);
    } catch (err) {
      console.error("Failed to enrich contact:", err);
    }
  };

  const renderEmail = (value) => {
    return (
      <>
        {value == NO_EMAIL || value == null ? (
          <AccessField
            field_value={updatedEmail || value}
            onAccessClick={(e) =>
              handleOnAccessEmailClick(e, user?.id, contactId, linkedin)
            }
          />
        ) : (
          <div>{value || <span className="scbc-na">N/A</span>}</div>
        )}
      </>
    );
  };

  const shouldRenderDecisionBadge =
    decisionMaker && DECISION_MAKER_STAT && BANT_FRAMEWORK && Object.keys(BANT_FRAMEWORK).length;


  return (
    <div className="contact-banner-container">
      {banner && (
        <GenericFloatingBanner
          key={banner.id}
          message={banner.message}
          title={banner.title}
          type={banner.type}
          duration={banner.duration}
          onClose={() => setBanner(null)}
        />
      )}
      <div className="contact-banner-avatar">{initials}</div>
      <div className="contact-banner-info">
        <div className="contact-banner-name">{name}</div>
        <div className="contact-banner-title">
          {title} • {company}
        </div>
        <div className="contact-banner-meta">
          {location && (
            <span className="contact-banner-icon-text">
              <MapPin size={14} /> {location}
            </span>
          )}
          {updatedEmail == null || updatedEmail == NO_EMAIL ? (
            renderEmail(updatedEmail)
          ) : (
            <a
              href={`mailto:${updatedEmail}`}
              className="contact-banner-icon-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Mail size={14} /> {updatedEmail}
            </a>
          )}
          {(updatedPhone || phone) ? (
            <span className="contact-banner-icon-text">
            <Phone  size={14}/>  {updatedPhone || phone}
            </span>
          ) : isPhonePending ? (
            <StatusIndicator text="Fetching Number" />
          ) : (
            <AccessPhoneButton
              phone={updatedPhone || phone}
              onAccessClick={(e) =>
                handleOnAccessPhoneClick(e, user?.id, contactId, true)
              }
              copyToClipboard={(value) => copyToClipboard(value, "phone")}
            />
          )}

          {linkedin && (
            <a
              href={linkedin}
              className="contact-banner-icon-text"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Linkedin size={14} /> LinkedIn
            </a>
          )}
        </div>
      </div>

      {shouldRenderDecisionBadge && (
        <ContactDetailsBannerBadge
          BANT_FRAMEWORK={BANT_FRAMEWORK}
          DECISION_MAKER_STAT={DECISION_MAKER_STAT}
        />
      )}
    </div>
  );
};

export default ContactDetailsBanner;
